import { render, staticRenderFns } from "./ObjectGroupsSortPage.vue?vue&type=template&id=2e5670ea&"
import script from "./ObjectGroupsSortPage.vue?vue&type=script&lang=js&"
export * from "./ObjectGroupsSortPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
